/**
 * [Phase 2c-B §4.12 NEW-3] Global now-playing indicator.
 *
 * Mounted at root inside <BrowserRouter> in App.js, so it survives every
 * route change and visibly indicates that Adam's audio is still rolling.
 */
import React from "react";
import { Volume2, X } from "lucide-react";
import { useTTSPlayer } from "../../contexts/TTSPlayerContext";

export default function NowPlayingIndicator() {
  const { state, stop } = useTTSPlayer();
  if (!state.playing) return null;

  return (
    <div
      data-testid="now-playing-indicator"
      className="fixed bottom-4 right-4 z-[100] w-[280px] rounded-2xl bg-[#1C1C1C] border border-[#FF6B00]/40 shadow-[0_8px_32px_rgba(0,0,0,0.5)] backdrop-blur-md overflow-hidden"
    >
      <div className="flex items-center gap-3 p-3">
        <div className="w-9 h-9 rounded-xl bg-[#FF6B00]/15 flex items-center justify-center shrink-0">
          <Volume2 size={16} className="text-[#FF6B00] animate-pulse" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[9px] uppercase tracking-widest text-[#FF6B00] font-display font-black">
            Adam Speaking
          </div>
          <div className="text-xs text-[#F5F5F5]/85 leading-tight line-clamp-2 mt-0.5">
            {state.snippet || "..."}
          </div>
        </div>
        <button
          onClick={() => stop()}
          data-testid="now-playing-stop-btn"
          className="w-7 h-7 rounded-lg flex items-center justify-center bg-white/[0.06] hover:bg-white/[0.12] transition-all shrink-0"
          aria-label="Stop audio"
        >
          <X size={14} className="text-[#F5F5F5]" />
        </button>
      </div>
    </div>
  );
}
